import React, {PureComponent, PropTypes} from 'react';
import Cookies from 'js-cookie';

import style from './bubble.module.css';
import closeImage from './close.png';
import controllerImage from './controller.png';

class Bubble extends PureComponent {

    constructor() {
        super();
        this.state = {};
    }

    static propTypes = {
        url: PropTypes.string,
        title: PropTypes.string,
        updated: PropTypes.string
    };

    _close = (e) => {
        e.preventDefault();
        
        Cookies.set('bubble_closed', this.props.updated, { expires: 365 });

        this.setState({
            closed: true
        });
    }

    render() {

        if (this.state.closed) {
            return null;
        }

        return (
            <div className={style.container}>
                <a onClick={this._close} href="" className={style.close}>
                    <img src={closeImage} />
                </a>
                <img className={style.controller} src={controllerImage}/>
                <div className={style.text}>{this.props.title}</div>

                <a href={this.props.url} className={style.readMoreButton}>{Exanimo.trans('find_out_more')}</a>
            </div>
        );
    }
}

export default Bubble;